import React, { useState } from "react";
import "./LocationSelector.css";

const data = {
  India: {
    Karnataka: ["Bangalore", "Mysore", "Mangalore"],
    Telangana: ["Hyderabad", "Warangal", "Karimnagar"],
    TamilNadu: ["Chennai", "Coimbatore", "Madurai"],
  },
  UAE: {
    Dubai: ["Downtown", "Marina", "Jumeirah"],
    AbuDhabi: ["Corniche", "Yas Island", "Al Khalidiyah"],
  }
};

export default function LocationSelector({ onChange }) {
  const [country, setCountry] = useState("India");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [address1, setAddress1] = useState("");

  const updateParent = (updated) => {
    onChange && onChange({
      country,
      state,
      city,
      address1,
      ...updated
    });
  };

  const handleCountryChange = (e) => {
    const value = e.target.value;
    setCountry(value);
    setState("");
    setCity("");
    updateParent({ country: value, state: "", city: "" });
  };

  const handleStateChange = (e) => {
    const value = e.target.value;
    setState(value);
    setCity("");
    updateParent({ state: value, city: "" });
  };

  const handleCityChange = (e) => {
    const value = e.target.value;
    setCity(value);
    updateParent({ city: value });
  };

  const handleAddressChange = (e) => {
    const value = e.target.value;
    setAddress1(value);
    updateParent({ address1: value });
  };

  return (
    <div className="location-grid">
      {/* Country */}
      <div className="form-group">
        <label>Country</label>
        <select value={country} onChange={handleCountryChange}>
          {Object.keys(data).map((c) => (
            <option key={c} value={c}>{c}</option>
          ))}
        </select>
      </div>

      {/* State */}
      <div className="form-group">
        <label>State</label>
        <select value={state} onChange={handleStateChange}>
          <option value="">Select State</option>
          {Object.keys(data[country]).map((s) => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
      </div>

      {/* City */}
      <div className="form-group">
        <label>City</label>
        <select value={city} onChange={handleCityChange}>
          <option value="">Select City</option>
          {state &&
            data[country][state].map((c) => (
              <option key={c} value={c}>{c}</option>
            ))}
        </select>
      </div>

      {/* Address Line 1 */}
      <div className="form-group full-width">
        <label>Address Line</label>
        <input
          type="text"
          placeholder="ABC Street; Oppo XYZ Capital Mall"
          value={address1}
          onChange={handleAddressChange}
        />
      </div>
    </div>
  );
}
